// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loader_wrapper__3H5pl","loader":"Loader_loader__2i9DI","loader1":"Loader_loader1__1DUH4","loader2":"Loader_loader2__6dyj_","loader3":"Loader_loader3__1FX-k"};